import { render, staticRenderFns } from "./MetricItemEditor.vue?vue&type=template&id=82d2d6ce"
import script from "./MetricItemEditor.vue?vue&type=script&lang=js"
export * from "./MetricItemEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports